module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"follow":"Folgen","unfollow":"Entfolgen"},"en":{"follow":"Follow","unfollow":"Unfollow"}}')
  delete Component.options._Ctor
}
